const packs_btns = document.querySelectorAll(".pack_box");
const selectedFixedProducts = document.querySelector(".selected-fixed-products");
const productCards = document.querySelectorAll(".builder_product_card");

const updateSelectedFixedProducts = (count) => {
  const stickyElement = document.querySelector(".selected-fixed-container");
  const existingElements = document.querySelectorAll(".selected-fixed-el");
  const currentCount = existingElements.length;
  let plusBtns = document.querySelectorAll('button[data-action="plus"]');

  stickyElement.classList.remove("atc-btn-active");

  if (currentCount < count) {
    for (let i = currentCount; i < count; i++) {
      const el = document.createElement("div");
      el.classList.add("selected-fixed-el");
      selectedFixedProducts.appendChild(el);
    }
    plusBtns.forEach((btn) => {
      btn.removeAttribute("disabled");
    });
  } else if (currentCount > count) {
    selectedFixedProducts.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const el = document.createElement("div");
      el.classList.add("selected-fixed-el");
      selectedFixedProducts.appendChild(el);
    }

    document.querySelectorAll(".builder_product_card").forEach((el) => {
      if (
        !document.querySelector(
          `.selected-fixed-el[data-id="${el.dataset.product_id}"]`
        )
      ) {
        el.querySelector(".builder_selected_qty").innerHTML = "0";
        el.querySelector(".builder_qty_selector").dataset.qty = "0";
        el
          .querySelector('.builder_qty_selector button[data-action="minus"]')
          .setAttribute("disabled", true);
        el
          .querySelector('.builder_qty_selector button[data-action="plus"]')
          .removeAttribute("disabled");
      }
    });
  }
};

function attributesHandler() {
  productCards.forEach((card) => {
    card.setAttribute("data-quantity-text", "0");
    card.setAttribute("data-quantity", "0");
  });
}

packs_btns.forEach((btn) => {
  btn.addEventListener("click", () => {
    packs_btns.forEach((btn) => btn.classList.remove("pack_box-active"));
    btn.classList.add("pack_box-active");
    const availablePacks = parseInt(btn.dataset.available_packs, 10);
    updateSelectedFixedProducts(availablePacks);
    attributesHandler();
    updateBlurredCards();
  });
});

document.addEventListener("DOMContentLoaded", function () {
 window.changeQty = function (button) {
  const action = button.getAttribute("data-action");
  const card = button.closest(".builder_product_card");
  const qtyDisplay = card.querySelector(".builder_selected_qty");
  const minusBtn = card.querySelector('button[data-action="minus"]');
  const plusBtn = card.querySelector('button[data-action="plus"]');

  let currentQty = parseInt(qtyDisplay.textContent || "0", 10);
  const packLimit = parseInt(document.querySelector(".pack_box-active")?.dataset.available_packs || "6", 10);

  // Count total selected
  let totalSelected = 0;
  document.querySelectorAll(".builder_product_card").forEach((el) => {
    totalSelected += parseInt(el.dataset.quantity || "0", 10);
  });

  if (action === "plus" && totalSelected >= packLimit) {
    console.log("[Limit Reached] Max cookies selected.");
    return;
  }

  if (action === "minus" && currentQty > 0) {
    currentQty--;
  } else if (action === "plus") {
    currentQty++;
  }

  // Set new qty
  card.dataset.quantity = currentQty;
  card.dataset.quantityText = `${currentQty}`;
  qtyDisplay.textContent = `${currentQty}`;

  // Disable/enable minus
  minusBtn.disabled = currentQty === 0;

  // Disable plus if we hit the limit
  let updatedTotal = 0;
  document.querySelectorAll(".builder_product_card").forEach((el) => {
    updatedTotal += parseInt(el.dataset.quantity || "0", 10);
  });

  const allPlusBtns = document.querySelectorAll('button[data-action="plus"]');
  allPlusBtns.forEach((btn) => {
    const parentCard = btn.closest(".builder_product_card");
    const qty = parseInt(parentCard.dataset.quantity || "0", 10);
    btn.disabled = updatedTotal >= packLimit && qty === 0;
  });
if (action === "plus" && currentQty === 1) {
  showCookieCounter();
  showMobileCounter();
}

  // Summary updates
  updateSummarySidebar();
updatePlusButtons();

  // Visual marker if needed
  updateSelectedEl(
    card.querySelector("img"),
    action,
    card.dataset.product_id,
    card.dataset.productTitle
  );
};

 // 👇 Show counters if needed
  if (currentQty > 0 || getTotalQty() > 0) {
    showCookieCounter();
    showMobileCounter();
  }
updateBlurredCards();
refreshPlusButtons();

});

function updatePlusButtons() {
  const packLimit = parseInt(document.querySelector(".pack_box-active")?.dataset.available_packs || "6", 10);
  let totalQty = 0;

  document.querySelectorAll(".builder_product_card").forEach((card) => {
    const qty = parseInt(card.getAttribute("data-quantity") || "0", 10);
    totalQty += qty;
  });

  document.querySelectorAll(".builder_product_card").forEach((card) => {
    const plusBtn = card.querySelector('button[data-action="plus"]');

    if (!plusBtn) return;

    if (totalQty >= packLimit) {
      plusBtn.disabled = true;
      plusBtn.classList.add("qty-disabled");
    } else {
      plusBtn.disabled = false;
      plusBtn.classList.remove("qty-disabled");
    }
  });
  updateBlurredCards()
};



function updateSummarySidebar() {
  const summaryItemsWrapper = document.getElementById("summaryItems");
  const cookieCounter = document.getElementById("cookieCounter");
  const cookieLimit = document.getElementById("cookieLimit");

 const summaryItemsMobile = document.getElementById("summaryItemsMobile");
const cookieCounterMobile = document.getElementById("cookieCounterMobile");
 const cookieLimitMobile = document.getElementById("cookieLimitMobile");

  summaryItemsWrapper.innerHTML = "";
  summaryItemsMobile.innerHTML = "";

  const allCards = document.querySelectorAll(".builder_product_card");
  let total = 0;
  let limit = parseInt(document.querySelector(".pack_box-active")?.dataset.available_packs || 6);

  allCards.forEach((card) => {
    const qty = parseInt(card.dataset.quantity || 0);
    if (qty > 0) {
      const title = card.dataset.productTitle;
      const id = card.dataset.product_id;

      const row = document.createElement("div");
      row.classList.add("summary-item");
      row.setAttribute("data-id", id);
      const pieceLabel = qty > 1 ? window.BUILDER_TRANSLATIONS.pieces : window.BUILDER_TRANSLATIONS.piece;

row.innerHTML = `
  <button onclick="removeFromSummary('${id}')"><svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.125" y="3.125" width="21.75" height="21.75" rx="10.875" fill="white" fill-opacity="0.01"/>
<rect x="1.125" y="3.125" width="21.75" height="21.75" rx="10.875" stroke="#3C3433" stroke-width="2.25"/>
<path d="M14.3531 10.0813L16.0077 11.736L13.6785 14.0652L16.0077 16.3944L14.3531 18.049L12.0239 15.7198L9.68193 18.0618L8.0273 16.4071L10.3692 14.0652L7.95117 11.6471L9.60581 9.99249L12.0239 12.4106L14.3531 10.0813Z" fill="#3C3433"/>
</svg></button>
  <span>${title}</span>
  <span>${qty} ${pieceLabel}</span>
`;

      summaryItemsWrapper.appendChild(row);
      summaryItemsMobile.appendChild(row.cloneNode(true));

      total += qty;
    }
  });

  cookieCounter.textContent = total;
  cookieLimit.textContent = limit;
  cookieCounterMobile.textContent = total;
  cookieLimitMobile.textContent = limit;
  //code for pop up counter info box
  const popupCounter = document.getElementById("popupCookieCounter");
const popupLimit = document.getElementById("popupCookieLimit");

if (popupCounter && popupLimit) {
  popupCounter.textContent = total;
  popupLimit.textContent = limit;
}
//code end for the popup counter

  // Toggle ATC button state for both desktop & mobile
  const addToCartBtn = document.querySelector(".atc-btn");
  const addToCartBtnMobile = document.querySelector(".atc-btn-mobile");

  if (total === limit) {
    addToCartBtn?.classList.remove("atc-btn-disabled");
    addToCartBtnMobile?.classList.remove("atc-btn-disabled");
  } else {
    addToCartBtn?.classList.add("atc-btn-disabled");
    addToCartBtnMobile?.classList.add("atc-btn-disabled");
  }

 

};

function updateBlurredCards() {
  const cards = document.querySelectorAll(".builder_product_card");
  const availablePack = parseInt(document.querySelector(".pack_box-active")?.dataset.available_packs || "6", 10);

  let totalQty = 0;

  cards.forEach((card) => {
    // Use dataset.quantity first, fallback to selector's dataset.qty
    let qty = parseInt(card.dataset.quantity || card.querySelector(".builder_qty_selector")?.dataset.qty || "0", 10);
    totalQty += qty;
    card.classList.remove("blurred"); // reset
  });

  if (totalQty >= availablePack) {
    cards.forEach((card) => {
      let qty = parseInt(card.dataset.quantity || card.querySelector(".builder_qty_selector")?.dataset.qty || "0", 10);
      if (qty === 0) {
        card.classList.add("blurred");
      }
    });
  }
}



const updateQtyActions = (button, currentQty, action) => {
  const qtySelectors = document.querySelectorAll(".builder_qty_selector");
  const available_packs = +document.querySelector(".pack_box-active").dataset.available_packs;
  let plusBtns = document.querySelectorAll('button[data-action="plus"]');
  const addToCartBtn = document.querySelector(".atc-btn");

  let totalQty = 0;
  qtySelectors.forEach((el) => {
    const qty = parseInt(el.dataset.qty || "0", 10);
    totalQty += qty;
  });

  // Update per-quantity selector
  if (button?.closest) {
    button.closest(".builder_qty_selector").dataset.qty = currentQty;
  }

  if (totalQty === available_packs) {
    plusBtns.forEach((btn) => btn.setAttribute("disabled", true));
    addToCartBtn.classList.remove("atc-btn-disabled");
  } else {
    plusBtns.forEach((btn) => btn.removeAttribute("disabled"));
    addToCartBtn.classList.add("atc-btn-disabled");
  }
};

const updateSelectedEl = (img, action, product_id, title) => {
  const selectedEls = document.querySelectorAll(".selected-fixed-el");

  if (action === "plus") {
    const imgClone = img.cloneNode(true);
    for (let el of selectedEls) {
      if (!el.querySelector("img")) {
        el.dataset.id = product_id;
        el.dataset.product_title = title;
        el.appendChild(imgClone);
        break;
      }
    }
  } else if (action === "minus") {
    let foundIndex = -1;
    for (let i = 0; i < selectedEls.length; i++) {
      const currentImg = selectedEls[i].querySelector("img");
      if (
        currentImg &&
        currentImg.src.split("/").pop() === img.src.split("/").pop()
      ) {
        selectedEls[i].removeAttribute("data-id");
        selectedEls[i].removeAttribute("data-product_title");
        selectedEls[i].removeChild(currentImg);
        foundIndex = i;
        break;
      }
    }
    if (foundIndex !== -1) {
      for (let i = foundIndex; i < selectedEls.length - 1; i++) {
        const nextImg = selectedEls[i + 1].querySelector("img");
        const nextDataId = selectedEls[i + 1].dataset.id;
        const nextProductTitle = selectedEls[i + 1].dataset.product_title;

        if (nextImg) {
          selectedEls[i].appendChild(nextImg.cloneNode(true));
          selectedEls[i + 1].removeChild(nextImg);
          selectedEls[i].dataset.id = nextDataId;
          selectedEls[i].dataset.product_title = nextProductTitle;
          selectedEls[i + 1].removeAttribute("data-id");
          selectedEls[i + 1].removeAttribute("data-product_title");
        }
      }
    }
  }
};

const productInput = document.querySelector(
  ".product-buy-buttons--input-builder"
);
const bundleItemProperties = document.getElementById("bundle_item_properties");
const buttonSubmitForm = document.querySelector(
  ".product-buy-buttons--primary-builder"
);

/*document.querySelector(".atc-btn").addEventListener("click", () => {
  setTimeout(() => {
    const selectedEls = document.querySelectorAll(".selected-fixed-products [data-id]");
    const flavorCount = {};

    selectedEls.forEach((el) => {
      const flavorId = el.dataset.id;
      const card = document.querySelector(`.builder_product_card[data-product_id="${flavorId}"]`);
      if (!card) return;

      const handle = card.dataset.product_handle;
      const title = card.dataset.productTitle;
      if (!flavorCount[handle]) {
        flavorCount[handle] = { title, quantity: 0 };
      }
      flavorCount[handle].quantity++;
    });
    
    let readableParts = [];
    let jsonArray = [];

    Object.entries(flavorCount).forEach(([handle, obj]) => {
      const { title, quantity } = obj;
      readableParts.push(`${title} - ${quantity}x`);
      jsonArray.push({ h: handle, q: quantity });
    });

    const readableString = readableParts.join(", ");
    const flavorJson = JSON.stringify(jsonArray);

    console.log("User-friendly text:", readableString);
    console.log("JSON for checks:", flavorJson);

    bundleItemProperties.value = readableString;

    let jsonInput = document.getElementById("bundle_item_properties_json");
    if (!jsonInput) {
      jsonInput = document.createElement("input");
      jsonInput.type = "hidden";
      jsonInput.id = "bundle_item_properties_json";
      jsonInput.name = "properties[_bundle_json]"; 
      document.querySelector("form[action='/cart/add']").appendChild(jsonInput);
    }
    jsonInput.value = flavorJson;

    const selectedBundleVariantID =
      document.querySelector(".pack_box-active")?.dataset.bundle_product;
    productInput.value = selectedBundleVariantID;

    buttonSubmitForm.click();
  }, 0);
});*/



function imagesHandler(image, wrapper) {
  const slide = document.createElement("div");
  slide.classList.add("swiper-slide");

  slide.innerHTML = `<img src="${image}" loading="lazy" alt="Builder product image" />`;
  wrapper.appendChild(slide);
}

const overlayContainer = document.querySelector(".builder-popup-container");
const clearBLocks = document.querySelectorAll(".clear-in-js");
const popupClose = document.querySelector(".builder-popup-close");
const quantityPlus = document.querySelector(".quantity-buttons--popup .plus");
const quantityMinus = document.querySelector(".quantity-buttons--popup .minus");

let mainSwiper;
let secondarySwiper;

function buttonDisabledHandler(mainButton, popupButton) {
  if (mainButton.disabled) {
    popupButton.setAttribute("disabled", "true");
  } else {
    popupButton.removeAttribute("disabled");
  }
}

// SHOPIFY VIDEO METAFIELD FIX
// VALUE-BASED VIDEO METHOD JAVASCRIPT
// FINAL PRODUCTION VERSION - Clean, working video popup
document.querySelectorAll(".builder_product_info, .info-icon").forEach((el) => {
  el.addEventListener("click", () => {
    const productCard = el.closest(".builder_product_card");

    if (productCard) {
      const description = productCard.dataset.productDescription;
      const images = productCard.dataset.productImages ? productCard.dataset.productImages.split(",") : [];
      const additionalImage = productCard.dataset.productAdditionalImage;
      const productVideoHtml = productCard.dataset.productVideoHtml;
      const productVideoSources = productCard.dataset.productVideoSources;
      const title = productCard.dataset.productTitle;
      const quantityText = productCard.dataset.quantityText;

      const minusButton = productCard.querySelector('.builder_qty_selector button[data-action="minus"]');
      const plusButton = productCard.querySelector('.builder_qty_selector button[data-action="plus"]');

      const descriptionWrapper = document.querySelector(".description");
      const titleWrapper = document.querySelector(".title");
      const mainImagesWrapper = document.querySelector(".builder-swiper .swiper-wrapper");
      const secondaryImagesWrapper = document.querySelector(".swiper-additional-builder .swiper-wrapper");
      const quantityTextWrapper = document.querySelector(".quantity-text");
      const thumbnailContainer = document.querySelector(".swiper-additional-builder");

      // Clear previous content
      if (mainImagesWrapper) mainImagesWrapper.innerHTML = '';
      if (secondaryImagesWrapper) secondaryImagesWrapper.innerHTML = '';

      // Update text content
      if (descriptionWrapper) descriptionWrapper.innerHTML = description;
      if (titleWrapper) titleWrapper.innerText = title;
      if (quantityTextWrapper) quantityTextWrapper.innerText = quantityText;
      
      const quantityPlus = document.querySelector(".quantity-buttons--popup .plus");
      const quantityMinus = document.querySelector(".quantity-buttons--popup .minus");
      
      if (quantityPlus) {
        quantityPlus.setAttribute("data-product-id", productCard.getAttribute("data-product_id"));
      }
      if (quantityMinus) {
        quantityMinus.setAttribute("data-product-id", productCard.getAttribute("data-product_id"));
      }

      buttonDisabledHandler(minusButton, quantityMinus);
      buttonDisabledHandler(plusButton, quantityPlus);

      // Collect unique media items
      let allMedia = [];
      let usedUrls = new Set();
      
      // Add main images (no duplicates)
      images.forEach((image) => {
        const cleanUrl = image.trim();
        if (cleanUrl && cleanUrl !== '' && !usedUrls.has(cleanUrl)) {
          usedUrls.add(cleanUrl);
          allMedia.push({ src: cleanUrl, type: 'image' });
        }
      });
      
      // Add additional image
      if (additionalImage && additionalImage.trim() && additionalImage.trim() !== '') {
        const cleanUrl = additionalImage.trim();
        if (!usedUrls.has(cleanUrl)) {
          usedUrls.add(cleanUrl);
          allMedia.push({ src: cleanUrl, type: 'image' });
        }
      }
      
      // Add video using Shopify .value method
      if (productVideoHtml && productVideoHtml.trim() && productVideoHtml.includes('<video')) {
        allMedia.push({ src: productVideoHtml.trim(), type: 'shopify_video' });
      } else if (productVideoSources && productVideoSources.trim()) {
        const sourceUrls = productVideoSources.split('|').filter(url => url.trim());
        if (sourceUrls.length > 0) {
          let videoHtml = '<video controls style="width:100%; height:100%; object-fit:cover;">';
          sourceUrls.forEach(url => {
            videoHtml += `<source src="${url.trim()}" type="video/mp4">`;
          });
          videoHtml += 'Your browser does not support the video tag.</video>';
          allMedia.push({ src: videoHtml, type: 'custom_video' });
        }
      }

      // Populate main swiper
      allMedia.forEach((media) => {
        const mainSlide = document.createElement("div");
        mainSlide.classList.add("swiper-slide");
        
        if (media.type === 'shopify_video' || media.type === 'custom_video') {
          mainSlide.innerHTML = media.src;
        } else {
          mainSlide.innerHTML = `<img src="${media.src}" loading="lazy" alt="Product media" style="width:100%; height:100%; object-fit:cover;" />`;
        }
        mainImagesWrapper.appendChild(mainSlide);
      });

      // Show thumbnails only if multiple media items
      if (allMedia.length > 1) {
        thumbnailContainer.style.display = 'block';
        
        allMedia.forEach((media) => {
          const thumbSlide = document.createElement("div");
          thumbSlide.classList.add("swiper-slide");
          
          if (media.type === 'shopify_video' || media.type === 'custom_video') {
            thumbSlide.classList.add("video-thumbnail");
            
            // Create a temporary video element to extract the first frame
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = media.src;
            const videoElement = tempDiv.querySelector('video');
            
            if (videoElement) {
              // Clone the video element for thumbnail
              const thumbVideo = videoElement.cloneNode(true);
              thumbVideo.muted = true;
              thumbVideo.controls = false;
              thumbVideo.style.cssText = 'width:100%; height:100%; object-fit:cover; pointer-events:none;';
              thumbVideo.preload = 'metadata';
              thumbVideo.currentTime = 1; // Show frame at 1 second
              
              // Create container with play overlay
              thumbSlide.innerHTML = `
                <div style="position: relative; width: 100%; height: 100%; overflow: hidden; border-radius: 4px;">
                  ${thumbVideo.outerHTML}
                  <div style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(0, 0, 0, 0.7);
                    color: white;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    pointer-events: none;
                  ">▶</div>
                  <div style="
                    position: absolute;
                    bottom: 2px;
                    right: 2px;
                    background: rgba(0, 0, 0, 0.8);
                    color: white;
                    padding: 1px 4px;
                    border-radius: 2px;
                    font-size: 8px;
                    font-weight: bold;
                  ">VIDEO</div>
                </div>
              `;
            } else {
              // Fallback to icon if video element can't be created
              thumbSlide.innerHTML = `
                <div style="
                  width:100%; 
                  height:100%; 
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  display:flex; 
                  align-items:center; 
                  justify-content:center; 
                  color:white; 
                  font-size:18px; 
                  position:relative; 
                  border-radius:4px;
                ">
                  ▶
                  <div style="
                    position:absolute; 
                    bottom:3px; 
                    right:3px; 
                    background:rgba(0,0,0,0.8); 
                    color:white; 
                    padding:2px 5px; 
                    border-radius:3px; 
                    font-size:8px;
                    font-weight:bold;
                  ">VIDEO</div>
                </div>
              `;
            }
          } else {
            thumbSlide.innerHTML = `<img src="${media.src}" loading="lazy" alt="Thumbnail" style="width:100%; height:100%; object-fit:cover;" />`;
          }
          secondaryImagesWrapper.appendChild(thumbSlide);
        });
      } else {
        thumbnailContainer.style.display = 'none';
      }

      // Initialize swipers
      setTimeout(() => {
        if (window.secondarySwiper) window.secondarySwiper.destroy(true, true);
        if (window.mainSwiper) window.mainSwiper.destroy(true, true);

        if (allMedia.length > 1) {
          window.secondarySwiper = new Swiper(".swiper-additional-builder", {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
          });

          window.mainSwiper = new Swiper(".builder-swiper", {
            slidesPerView: 1,
            speed: 600,
            thumbs: {
              swiper: window.secondarySwiper
            },
            on: {
              slideChange: function () {
                const videos = document.querySelectorAll('.builder-swiper video');
                videos.forEach(video => video.pause());
              }
            }
          });
        } else {
          window.mainSwiper = new Swiper(".builder-swiper", {
            slidesPerView: 1,
            speed: 600
          });
        }
      }, 100);

      // Show popup
      document.querySelector(".builder-popup-overlay").classList.add("builder-popup-overlay-active");
      document.body.classList.add("overflow");
    }
  });
});




function buttonPopupHandler(id, action) {
  const productCard = document.querySelector(
    `.builder_product_card[data-product_id="${id}"]`
  );
  if (productCard) {
    const plusButton = productCard.querySelector(
      '.builder_qty_selector [data-action="plus"]'
    );
    const minusButton = productCard.querySelector(
      '.builder_qty_selector [data-action="minus"]'
    );
    const quantityText = productCard.querySelector(".builder_selected_qty");

    if (action == "plus") {
      plusButton.click();
    } else {
      minusButton.click();
    }

    setTimeout(() => {
      const popUpQuantityText = document.querySelector(
        ".builder-popup-overlay .quantity-text"
      );
      popUpQuantityText.innerText = quantityText.innerText;

      buttonDisabledHandler(plusButton, quantityPlus);
      buttonDisabledHandler(minusButton, quantityMinus);
    }, 0);
  }
}

quantityPlus.addEventListener("click", () => {
  buttonPopupHandler(quantityPlus.getAttribute("data-product-id"), "plus");
});
quantityMinus.addEventListener("click", () => {
  buttonPopupHandler(quantityPlus.getAttribute("data-product-id"), "minus");
});

function popupCloseHandler() {
  const videos = document.querySelectorAll('.builder-popup-container video');
  videos.forEach(video => {
    video.pause();
    video.currentTime = 0;
  });

  document.querySelector(".builder-popup-overlay").classList.remove("builder-popup-overlay-active");
  document.body.classList.remove("overflow");
  
  const clearBlocks = document.querySelectorAll(".clear-in-js");
  clearBlocks.forEach((block) => {
    block.innerHTML = "";
  });
  
  if (window.mainSwiper) {
    window.mainSwiper.destroy(true, true);
    window.mainSwiper = null;
  }
  if (window.secondarySwiper) {
    window.secondarySwiper.destroy(true, true);
    window.secondarySwiper = null;
  }
}

document
  .querySelector(".builder-popup-overlay")
  .addEventListener("click", (e) => {
    if (e.target.classList.contains("builder-popup-overlay")) {
      popupCloseHandler();
    }
  });

popupClose.addEventListener("click", () => {
  popupCloseHandler();
});




let originalQuantity = 1;

document.addEventListener("DOMContentLoaded", async () => {
    const packsWrapper = document.querySelector(".packs_selector_wrapper");
    const packs_btns = document.querySelectorAll(".pack_box");
    packsWrapper.style.visibility = "hidden";

    const params = new URLSearchParams(window.location.search);
    const lineKey = params.get("line");
  
    if (!lineKey) {
      console.warn("No 'line' param found. Cannot edit a specific item.");
      packsWrapper.style.visibility = "visible";
      return;
    }
  
    try {
      const res = await fetch("/cart.js");
      const cartJson = await res.json();
      const lineItem = cartJson.items.find((item) => item.key === lineKey);
      
      if (!lineItem) {
        console.warn("No matching line item found in cart for lineKey:", lineKey);
        packsWrapper.style.visibility = "visible";
        return;
      }

      originalQuantity = lineItem.quantity;

      const chosenVariantId = lineItem.variant_id.toString(); 
      console.log("[EditFlow] The user chose variant:", chosenVariantId);

      packs_btns.forEach((pack) => pack.style.display = "none");

      const matchingBox = document.querySelector(
        `.pack_box[data-bundle_product="${chosenVariantId}"]`
      );

      if (matchingBox) {
        matchingBox.style.display = "block";
        matchingBox.click(); // Set active state
      } else {
        console.warn("No .pack_box found for variant_id:", chosenVariantId);
      }

      packsWrapper.style.visibility = "visible";

      if (lineItem.properties && lineItem.properties["_bundle_json"]) {
        const flavorArray = JSON.parse(lineItem.properties["_bundle_json"]);
        console.log("Existing flavors to preselect:", flavorArray);

        flavorArray.forEach(({ h, q }) => {
          const card = document.querySelector(
            `.builder_product_card[data-product_handle="${h}"]`
          );
          if (card) {
            for (let i = 0; i < q; i++) {
              const plusBtn = card.querySelector(
                '.builder_qty_selector [data-action="plus"]'
              );
              plusBtn.click();
            }
          } else {
            console.log("Flavor not found in builder:", h);
          }
        });
      }
    } catch (err) {
      console.error("Error fetching cart for line item data:", err);
      packsWrapper.style.visibility = "visible"; // Ensure visibility even on error
    }
  
   const updateButton = document.querySelector(".update-bundle-btn");
   const updateButtonMobile = document.querySelector(".update-bundle-btn-mobile");

if (updateButton) {
  updateButton.addEventListener("click", async () => {
    const params = new URLSearchParams(window.location.search);
    const lineKey = params.get("line");

    const bundleVariantId = document.querySelector(".pack_box-active")?.dataset.bundle_product;
    if (!bundleVariantId) {
      console.error("No bundle variant selected.");
      return;
    }

    const selectedCards = document.querySelectorAll(".builder_product_card[data-quantity]:not([data-quantity='0'])");

    const readableParts = [];
    const flavorJsonArray = [];

    selectedCards.forEach((card) => {
      const title = card.dataset.productTitle;
      const handle = card.dataset.product_handle;
      const qty = parseInt(card.dataset.quantity || "0", 10);

      readableParts.push(`${title} - ${qty}x`);
      flavorJsonArray.push({ h: handle, q: qty });
    });

    if (flavorJsonArray.length === 0) {
      alert("Please select at least one cookie.");
      return;
    }

    const readableString = readableParts.join(", ");
    const flavorJson = JSON.stringify(flavorJsonArray);

    try {
      // Step 1: Remove the original bundle line item
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });

      // Step 2: Add the updated bundle ONLY (no single flavors)
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(bundleVariantId),
              quantity: 1,
              properties: {
                "Bundle items": readableString,
                "_bundle_json": flavorJson
              }
            }
          ]
        }),
      });

      // Step 3: Redirect back to cart
      const redirectURL = (typeof window.BUILDER_EDIT_REDIRECT === "string" && window.BUILDER_EDIT_REDIRECT.length)
  ? window.BUILDER_EDIT_REDIRECT
  : "/cart";

console.log("Redirecting user to:", redirectURL);

localStorage.setItem("openCartDrawer", "true");
window.location.href = redirectURL;
    } catch (err) {
      console.error("Error updating bundle:", err);
    }
  });
};


if (updateButtonMobile) {
  updateButtonMobile.addEventListener("click", async () => {
    const params = new URLSearchParams(window.location.search);
    const lineKey = params.get("line");

    const bundleVariantId = document.querySelector(".pack_box-active")?.dataset.bundle_product;
    if (!bundleVariantId) {
      console.error("No bundle variant selected.");
      return;
    }

    const selectedCards = document.querySelectorAll(".builder_product_card[data-quantity]:not([data-quantity='0'])");

    const readableParts = [];
    const flavorJsonArray = [];

    selectedCards.forEach((card) => {
      const title = card.dataset.productTitle;
      const handle = card.dataset.product_handle;
      const qty = parseInt(card.dataset.quantity || "0", 10);

      readableParts.push(`${title} - ${qty}x`);
      flavorJsonArray.push({ h: handle, q: qty });
    });

    if (flavorJsonArray.length === 0) {
      alert("Please select at least one cookie.");
      return;
    }

    const readableString = readableParts.join(", ");
    const flavorJson = JSON.stringify(flavorJsonArray);

    try {
      // Step 1: Remove the original bundle line item
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });

      // Step 2: Add the updated bundle ONLY (no single flavors)
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(bundleVariantId),
              quantity: 1,
              properties: {
                "Bundle items": readableString,
                "_bundle_json": flavorJson
              }
            }
          ]
        }),
      });

      // Step 3: Redirect back to cart
      const redirectURL = (typeof window.BUILDER_EDIT_REDIRECT === "string" && window.BUILDER_EDIT_REDIRECT.length)
  ? window.BUILDER_EDIT_REDIRECT
  : "/cart";

console.log("Redirecting user to:", redirectURL);

localStorage.setItem("openCartDrawer", "true");
window.location.href = redirectURL;
    } catch (err) {
      console.error("Error updating bundle:", err);
    }
  });
}



  });

//remove button
function removeFromSummary(productId) {
  const card = document.querySelector(`.builder_product_card[data-product_id="${productId}"]`);
  if (!card) return;

  // Reset qty on the product card
  card.dataset.quantity = "0";
  card.dataset.quantityText = "0";

  const qtySelector = card.querySelector(".builder_qty_selector");
  qtySelector.dataset.qty = "0";
  qtySelector.setAttribute("data-qty", "0");
  qtySelector.querySelector(".builder_selected_qty").textContent = "0";
  qtySelector.querySelector('button[data-action="minus"]').setAttribute("disabled", true);

  // Unblur the removed card immediately
  card.classList.remove("blurred");

  // Remove from selected fixed bar
  document.querySelectorAll(".selected-fixed-products .selected-fixed-el").forEach((el) => {
    if (el.dataset.id === productId) {
      el.innerHTML = "";
      el.removeAttribute("data-id");
      el.removeAttribute("data-product_title");
    }
  });

  // Remove from summary list
  document.querySelectorAll(".summary-item").forEach((row) => {
    if (row.dataset.id === productId) row.remove();
  });

  // Update counters & states
  updateSummarySidebar();
  updateBlurredCards();
  updatePlusButtons();

  reEnablePlusButtons(); // <- ensures plus is clickable after removal
  refreshPlusButtons();

}

function reEnablePlusButtons() {
  const availablePack = parseInt(document.querySelector(".pack_box-active")?.dataset.available_packs || 0, 10);
  let totalQty = 0;

  document.querySelectorAll(".builder_product_card").forEach((card) => {
    totalQty += parseInt(card.dataset.quantity || "0", 10);
  });

  document.querySelectorAll('button[data-action="plus"]').forEach((btn) => {
    const parentCard = btn.closest(".builder_product_card");
    const cardQty = parseInt(parentCard.dataset.quantity || "0", 10);

    // Enable plus if we have space OR this card already has qty
    if (totalQty < availablePack || cardQty > 0) {
      btn.removeAttribute("disabled");
    } else {
      btn.setAttribute("disabled", true);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const atcBtns = document.querySelectorAll(".atc-btn, .atc-btn-mobile");
  atcBtns.forEach((btn) => {
    btn.classList.add("atc-btn-disabled");
  });

  // ✅ Set plus button state right away
  refreshPlusButtons();
});

function refreshPlusButtons() {
  const packLimit = parseInt(document.querySelector(".pack_box-active")?.dataset.available_packs || "6", 10);
  let totalQty = 0;

  document.querySelectorAll(".builder_product_card").forEach(card => {
    totalQty += parseInt(card.dataset.quantity || "0", 10);
  });

  document.querySelectorAll('button[data-action="plus"]').forEach(btn => {
    const parentCard = btn.closest(".builder_product_card");
    const qty = parseInt(parentCard.dataset.quantity || "0", 10);

    if (totalQty >= packLimit && qty === 0) {
      btn.disabled = true;
    } else {
      btn.disabled = false;
    }
  });
}



document.addEventListener("DOMContentLoaded", () => {
  const atcBtn = document.querySelectorAll(".atc-btn");
  const atcBtnMobile = document.querySelector(".atc-btn-mobile");

  atcBtn?.classList.add("atc-btn-disabled");
  atcBtnMobile?.classList.add("atc-btn-disabled");
});


document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.getElementById("summaryToggle");
  const itemsBox = document.getElementById("summaryItemsMobile");
  const arrow = document.getElementById("summaryArrow");
  itemsBox?.classList.add("collapsed");
    arrow?.classList.remove("rotated");

  toggleBtn?.addEventListener("click", () => {
    const isCollapsed = itemsBox.classList.toggle("collapsed");
    arrow.classList.toggle("rotated", !isCollapsed);
  });
});


//for hiding the cookies box message 
function showCookieCounter() {
  document.querySelector(".builder-summary__empty-state")?.classList.add("hidden");
  document.querySelector(".builder-summary__header")?.classList.remove("hidden");
}

function showMobileCounter() {
  document.querySelector('.empty-state-text-mobile')?.classList.add('hidden');
  document.querySelector('.cookie-counter-text-mobile')?.classList.remove('hidden');
}
